module.exports = __webpack_public_path__ + "img/045.8a8e5b02.png";